import TomSelect from 'tom-select';
import { computePosition, offset, flip } from '@floating-ui/dom';
import { gsap } from 'gsap';

function handleDropdownOpen() {
  const parent = this.control.parentElement.parentElement;
  const swiperSlide = parent.parentElement.classList.contains('swiper-slide')
    ? parent.parentElement
    : null;
  const placement = parent.dataset.dropdownPlacement || 'bottom-start';
  computePosition(this.control, this.dropdown, {
    middleware: [flip()],
    placement,
  }).then(({ x, y, placement }) => {
    this.control.parentElement.dataset.dropdownPlacement = placement;

    if (swiperSlide) gsap.set(swiperSlide, { zIndex: 2 });

    gsap.set(this.dropdown, {
      left: x,
      top: y,
    });
    gsap.fromTo(
      this.dropdown,
      { y: -5, autoAlpha: 0 },
      { y: 0, autoAlpha: 1, duration: 0.3, ease: 'power3.out' },
    );
  });
}

function handleDropdownClose() {
  const parent = this.control.parentElement.parentElement;
  const swiperSlide = parent.parentElement.classList.contains('swiper-slide')
    ? parent.parentElement
    : null;

  gsap.set(swiperSlide, {
    clearProps: 'zIndex',
  });
  gsap.to(this.dropdown, {
    y: -5,
    autoAlpha: 0,
    duration: 0.25,
    ease: 'power3.out',
  });
}

function handlePopupOpen() {
  const placement =
    this.control.parentElement.parentElement.dataset.dropdownPlacement ||
    'bottom-start';
  computePosition(this.control, this.dropdown, {
    middleware: [offset(12), flip()],
    placement,
  }).then(({ x, y, placement }) => {
    this.control.parentElement.dataset.dropdownPlacement = placement;

    gsap.set(this.dropdown, {
      left: x,
      top: y,
    });
    gsap.fromTo(
      this.dropdown,
      { y: 5, autoAlpha: 0 },
      { y: 0, autoAlpha: 1, duration: 0.3, ease: 'power3.out' },
    );
  });
}

function handlePopupClose() {
  gsap.to(this.dropdown, {
    y: 5,
    autoAlpha: 0,
    duration: 0.25,
    ease: 'power3.out',
  });
}

const defaultTomSelectSettings = {
  controlInput: null,
  copyClassesToDropdown: false,
  allowEmptyOption: true,
  optionClass: 'select__option',
  itemClass: 'item',
  render: {
    item: (data, escape) => {
      return (
        '<div><span>' +
        escape(data.shortLabel ? data.shortLabel : data.text) +
        '</span></div>'
      );
    },
  },
};

export function initSelect(parentElement, tomSelectSettings = {}) {
  if (!parentElement) return;

  const select = parentElement.querySelector('select');
  if (!select) return;

  const hasSearch = parentElement.classList.contains('js-select--has-search');
  const doShowValue = parentElement.classList.contains(
    'js-select--do-show-value',
  );

  const isDropdown = parentElement.classList.contains(
    'select--has-generic-dropdown',
  );
  const handleDropdownOpenFunc = isDropdown
    ? handleDropdownOpen
    : handlePopupOpen;
  const handleDropdownCloseFunc = isDropdown
    ? handleDropdownClose
    : handlePopupClose;

  let settings = {
    ...defaultTomSelectSettings,
    onDropdownOpen: handleDropdownOpenFunc,
    onDropdownClose: handleDropdownCloseFunc,
    ...tomSelectSettings,
  };

  if (hasSearch) settings.plugins = ['dropdown_input'];

  if (doShowValue) {
    settings.render = {
      item: (data, escape) => {
        return `<div>${escape(data.value)}</div>`;
      },
    };
  }

  return new TomSelect(select, settings);
}

export function initSelects(selector = '.js-select') {
  const selects = document.querySelectorAll(selector);
  selects.forEach((select) => initSelect(select));
}
